import React from "react";

export default function PageHeader({ overline, title, description, actions, testId }) {
  return (
    <div
      data-testid={testId || "page-header"}
      className="px-4 sm:px-6 md:px-10 py-5 sm:py-8 border-b vsm-border vsm-surface"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div className="max-w-3xl">
          {overline && <div className="vsm-overline mb-2">{overline}</div>}
          <h1
            className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight leading-none"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            {title}
          </h1>
          {description && (
            <p className="mt-3 text-sm vsm-muted leading-relaxed">{description}</p>
          )}
        </div>
        {actions && <div className="flex flex-wrap gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
